import React, { useEffect, useState } from "react";
import { Card, CardBody, CardFooter, CardTitle, Row, Col, } from "reactstrap";
import { BASE_URL } from "../../../constants";
import { Bar, Line } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);
// import LineChart from "../dashboard/_chart1.js";
// import PieChart from "../dashboard/_chart2.js";
// import LineChart2 from "../dashboard/_chart3.js";


function Dashboard() {
  const [areaCount, setAreaCount] = useState(0);
  const [usersCount, setUsersCount] = useState(0);
  const [packageCount, setPackageCount] = useState(0);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [priceCalculation, setPriceCalculation] = useState([]);

  console.log(priceCalculation, 'priceCalculation')
  console.log(areaCount, usersCount, 'count')
  useEffect(() => {
    fetchAreasData();
    fetchUsersData();
    fetchPackagesData();
    fetchSubscriptionData();
    fetchPriceCalculation();
  }, []);

  const fetchUsersData = () => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${BASE_URL}/user/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          console.log(data, 'data');
          if (data.status) {
            setUsersCount(data.result.meta_info.total_results);
          } else {
            console.error("Error: Unable to fetch users data.");
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    } else {
      console.error("Error: Authorization token is missing.");
    }
  };

  const fetchAreasData = () => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${BASE_URL}/area/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          console.log(data, 'data');
          if (data.status) {
            setAreaCount(data.result.meta_info.total_results);
          } else {
            console.error("Error: Unable to fetch property data.");
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    } else {
      console.error("Error: Authorization token is missing.");
    }
  };

  const fetchPackagesData = () => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${BASE_URL}/package/list/`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            const packages = data.result.data.map(pkg => ({
              name: pkg.title,
              totalCount: pkg.allowed_users
            }));
            setPackageCount(data.result.meta_info.total_results);
          } else {
            console.error("Error: Unable to fetch packages data.");
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    } else {
      console.error("Error: Authorization token is missing.");
    }
  };

  const fetchSubscriptionData = () => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${BASE_URL}/subscription/all`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            // Set the subscription data (package_name and total)
            const subscriptionData = data.result.map(sub => ({
              packageName: sub.package_name,
              total: sub.total
            }));
            setSubscriptionData(subscriptionData);
          } else {
            console.error("Error: Unable to fetch subscription data.");
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    } else {
      console.error("Error: Authorization token is missing.");
    }
  };


  const fetchPriceCalculation = () => {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${BASE_URL}/subscription/calculate-price`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            // Set the subscription data (package_name and total)
            const subscriptionData = data.result.map(sub => ({
              start_date: sub.start_date,
              total: sub.total
            }));
            setPriceCalculation(subscriptionData);
          } else {
            console.error("Error: Unable to fetch subscription data.");
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    } else {
      console.error("Error: Authorization token is missing.");
    }
  };

  const chartData = {
    labels: subscriptionData.map(sub => sub.packageName),
    datasets: [
      {
        label: "Subscriptions",
        data: subscriptionData.map(sub => sub.total),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      }
    ]
  };

  const chartDataLine = {
    labels: priceCalculation.map(sub => sub.start_date),
    datasets: [
      {
        label: "Earnings",
        data: priceCalculation.map(sub => sub.total),
        fill: false,
        borderColor: 'rgba(75, 192, 192, 1)',
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        tension: 0.4
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col xs="4">
            <Card className="card-stats">
              <CardBody style={{ paddingBottom: '30px' }}>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-bank text-warning" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Amenities</p>
                      <CardTitle tag="p">{areaCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              {/* <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fas fa-sync-alt" /> Update Now
                </div>
              </CardFooter> */}
            </Card>
          </Col>

          <Col xs="4">
            <Card className="card-stats">
              <CardBody style={{ paddingBottom: '30px' }}>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-single-02 text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Users</p>
                      <CardTitle tag="p">{usersCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              {/* <CardFooter>
                <hr />
                <div className="stats">
                  <i className="far fa-clock" /> In the last hour
                </div>
              </CardFooter> */}
            </Card>
          </Col>


          <Col xs="4">
            <Card className="card-stats">
              <CardBody style={{ paddingBottom: '30px' }}>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-box text-info" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Packages</p>
                      <CardTitle tag="p">{packageCount}</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              {/* <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fas fa-sync-alt" /> Update Now
                </div>
              </CardFooter> */}
            </Card>
          </Col>

        </Row>

        <Row>
          <Col xs="6">
            <Card>
              <CardBody>
                <h4>Packages Usage Overview</h4>
                <Bar data={chartData} options={chartOptions} />
              </CardBody>
            </Card>
          </Col>

          <Col xs="6">
            <Card>
              <CardBody>
                <h4>Monthly Earnings Overview</h4>
                <Line data={chartDataLine} options={chartOptions} />
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <h4>Monthly Earnings Overview</h4>
                <Line data={chartDataLine} options={chartOptions} />
              </CardBody>
            </Card>
          </Col>
        </Row> */}

      </div>
    </>
  );
}


export default Dashboard;
